/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductCategoryDto } from '../../models/product-category-dto';
import { UpdateProductCategoryDto } from '../../models/update-product-category-dto';

export interface ProductCategoryControllerUpdate$Params {

/**
 * Category ID
 */
  id: string;
      body: UpdateProductCategoryDto
}

export function productCategoryControllerUpdate(http: HttpClient, rootUrl: string, params: ProductCategoryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, productCategoryControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductCategoryDto>;
    })
  );
}

productCategoryControllerUpdate.PATH = '/api/product-category/{id}';
